export default __webpack_public_path__ + "static/media/corporationManager.7c5e79eb.svg";